import { ArrowUpRight, Disc3, Footprints, Heart, HousePlug, Mountain } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

import { INTERESTS } from '../data/site'
import type { Interest } from '../data/site'
import { Reveal } from './Reveal'
import { Section } from './Section'
import styles from './Life.module.css'

const ICONS: Record<Interest['icon'], LucideIcon> = {
  run: Footprints,
  vinyl: Disc3,
  home: HousePlug,
  family: Heart,
  mountain: Mountain
}

export function Life() {
  return (
    <Section
      id="life"
      eyebrow="Off the clock"
      title="The rest of it."
      lead="The interests that keep the technical muscles warm — and the ones that have nothing to do with computers at all."
    >
      <ul className={styles.grid}>
        {INTERESTS.map((interest, i) => {
          const Icon = ICONS[interest.icon]
          const isLink = Boolean(interest.href)

          return (
            <li key={interest.title}>
              <Reveal delay={Math.min(i * 70, 240)}>
                <article className={styles.card} data-linked={isLink || undefined}>
                  <span className={styles.icon} aria-hidden="true">
                    <Icon size={19} />
                  </span>

                  <h3 className={styles.title}>
                    {isLink ? (
                      // The whole card is clickable via the ::after overlay below,
                      // but the accessible target stays the link text itself.
                      <a className={styles.link} href={interest.href}>
                        {interest.title}
                      </a>
                    ) : (
                      interest.title
                    )}
                  </h3>

                  <p className={styles.blurb}>{interest.blurb}</p>

                  {interest.cta && (
                    <p className={styles.cta} aria-hidden="true">
                      {interest.cta}
                      <ArrowUpRight size={14} />
                    </p>
                  )}
                </article>
              </Reveal>
            </li>
          )
        })}
      </ul>
    </Section>
  )
}
